/**
 * Marketing Modal System Constants
 *
 * Centralizes technical constants for the marketing modal architecture.
 */

export const USER_INTENT_EVENTS = {
    EXIT: 'exit',
    THREE_PAGE_VIEWS: 'three_page_views',
} as const;

export const GTM_EVENTS = {
    [USER_INTENT_EVENTS.EXIT]: 'show-exit-modal-newsletter',
    [USER_INTENT_EVENTS.THREE_PAGE_VIEWS]: 'show-three-page-views-modal-newsletter',
} as const;

export const ACQUISITION_TAGS = {
    // Default modals
    [USER_INTENT_EVENTS.EXIT]: 'generic_popin_overlay_exit',
    [USER_INTENT_EVENTS.THREE_PAGE_VIEWS]: 'generic_popin_overlay_3pageviews',

    // OP campaigns
    WINTER_2025: (country: string) => `${country}_winter-endless-possibilities_2025_popin`,
    WINTER_GIVEAWAY: (country: string) => `${country}_wintergiveaway_2025_popin`,
} as const;

export const TRACKING_ORIGINS = {
    [USER_INTENT_EVENTS.EXIT]: 'exit',
    [USER_INTENT_EVENTS.THREE_PAGE_VIEWS]: 'three_page_views',
} as const;
